import { ICON__flame } from '@/assets/icons_fa';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { REMOTE__generation_create_for_field_consumer } from '@/state/generation/user_task/REMOTE__generation_create_for_field_consumer';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { HOOK_REQUEST_FOR_FIELD_CONSUMER__create } from '../../_base/context_menu/image/HOOK_REQUEST_FOR_FIELD_CONSUMER__create';
import { G_BUTTON__image_asset_create_base } from './G_BUTTON__image_asset_create_base';

interface PROPS {
  field_consumer: FIELD__image_asset;
  generation_tool: DTO__generation_tool;
}

export function G_BUTTON__image_asset_create_with_generation({ field_consumer, generation_tool }: PROPS) {
  const dispatch = use_dispatch();

  let request = HOOK_REQUEST_FOR_FIELD_CONSUMER__create(field_consumer, generation_tool);

  /*
   * EVENTS
   */
  async function onClick() {
    await dispatch(REMOTE__generation_create_for_field_consumer(request));
  }

  /*
   * HTML
   */

  if (generation_tool.is_stub()) return null;
  if (request.is_stub()) return null;

  return <G_BUTTON__image_asset_create_base {...{ onClick }} text={generation_tool.name} Icon={ICON__flame} />;
}
